import { v4 as uuid } from 'uuid';

import { logToConsole } from '../services/loggers/logToConsole';
import { ERROR } from '../constants/LogLevels';
import { axiosNetworkErrorFilter } from '../services/filters';
import { Config } from '../types/config';
import { LoggingFilter } from '../types/filter';
import { observePerformanceMetrics } from '../services/LogService';
import { reportWebVitals } from '../services/webVitals/reportWebVitals';

export const defaultFilters: LoggingFilter[] = [axiosNetworkErrorFilter];

export const config: Config = {
  sessionId: uuid(),
  endpoint: '',
  application: '',
  logToConsole: false,
  batchSize: 10,
  batchTimeout: 1000,
  defaultMetadata: {},
  loggingFilters: defaultFilters,
  performanceEntryTypes: ['first-input', 'paint', 'largest-contentful-paint', 'navigation'],
  disableWebVitals: false,
};

export const configure = (configuration?: Partial<Config>) => {
  if (!configuration) {
    logToConsole(ERROR, 'no configuration provided.');
    return;
  }

  if (!configuration.endpoint) {
    logToConsole(ERROR, 'property "endpoint" is missing from configuration.');
    return;
  }

  if (!configuration.application) {
    logToConsole(ERROR, 'property "application" is missing from configuration.');
    return;
  }

  // removing sessionId, since it is generated automatically and must not be overwritten
  if (configuration.sessionId) {
    delete configuration.sessionId;
  }

  if (!configuration.disableWebVitals) {
    reportWebVitals();
  }

  Object.assign(config, configuration);

  if (config.performanceEntryTypes) {
    observePerformanceMetrics({ types: config.performanceEntryTypes });
  }
};

export const setMetadata = (field: string, value: unknown) => {
  config.defaultMetadata[field] = value;
};

export const removeMetadata = (field: string) => {
  if (config?.defaultMetadata?.[field]) {
    delete config.defaultMetadata[field];
  }
};
